import { Chip } from '@mui/material'

/** Small label for features still in beta / experimental validation. */
export function BetaFeatureChip({ label = 'Beta', sx, ...rest }) {
  return (
    <Chip
      label={label}
      size="small"
      color="info"
      variant="outlined"
      sx={{ fontWeight: 600, flexShrink: 0, ...sx }}
      {...rest}
    />
  )
}
